import $ from 'jquery';
import mediumZoom from 'medium-zoom';

const responsiveStyles = {
  sm: 'tablet',
  md: 'tablet_pro',
  lg: 'desktop',
  xl: 'desktop_xl',
};

const breakpoints = {
  sm: '(min-width: 768px) and (max-width: 1023px)',
  md: '(min-width: 1024px) and (max-width: 1439px)',
  lg: '(min-width: 1440px) and (max-width: 1919px)',
  xl: '(min-width: 1920px)',
};

function getImgSrcByBreakpoint() {
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(breakpoints)) {
    if (window.matchMedia(value).matches) {
      return responsiveStyles[key];
    }
  }
}

const initZoomInMedia = (el) => {
  const $this = $(el);
  const btnZoomIn = $this.find('[data-target=zoom-in]');
  const btnZoomOut = $this.find('[data-target=zoom-out]');
  const cursor = $this.find('.zoom-in__overlay');

  const media = $this.find('img');

  if (media.length > 0) {
    media.map((i, img) => {
      const parent = $(img).parentsUntil('.images-stack');
      if (parent.hasClass('images-stack__image--hover')) {
        return;
      }

      const responsiveStyle = getImgSrcByBreakpoint();

      const siblings = $(img).siblings('source');
      const src = $(siblings)
        .toArray()
        .find((item) => ($(item).attr('srcset').includes(responsiveStyle) ? $(item) : null));

      $(img).attr('data-zoomable', '');
      if (src && src.tagName === 'SOURCE') {
        const trimmedSrc = src.getAttribute('srcset').split(' ')[0];
        return $(img).attr('data-zoom-src', trimmedSrc);
      }
      return null;
    });

    const zoom = mediumZoom($(media).toArray(), {
      background: 'rgba(0, 0, 0, 0.7)',
      margin: 40,
    });

    zoom.on('open', (e) => {
      $(e.target).css({ maxWidth: 'none' });
      $(e.target).parents('.zoom-in').addClass('zoomed');
    });

    zoom.on('opened', () => {
      $('.medium-zoom-overlay').append(btnZoomOut);
    });

    zoom.on('close', (e) => {
      $(e.target).css({ maxWidth: '' });
      $(e.target).parents('.zoom-in').removeClass('zoomed');
    });

    zoom.on('closed', () => {
      $('.medium-zoom-overlay').remove(btnZoomOut);
    });

    btnZoomIn.on('click', () => {
      zoom.open();
    });

    btnZoomIn.on('keydown', (e) => {
      const key = e.key || e.keyCode;

      if (key === 13 || key === 'Enter') {
        zoom.open();
      }
    });

    btnZoomOut.on('click', () => {
      zoom.close();
    });

    if (cursor.length > 0) {
      cursor.on('mousemove', (e) => {
        $(cursor).css({
          backgroundPositionX: `${e.offsetX}px`,
          backgroundPositionY: `${e.offsetY}px`,
        });
      });
    }
  }
};

// eslint-disable-next-line func-names
(function (window, Drupal) {
  Drupal.behaviors.mstZoomInMedia = {
    attach(context) {
      $('.zoom-in', context).each((index, element) => initZoomInMedia(element));
    },
  };
}(window, Drupal));
